import { Component, OnDestroy, OnInit, EventEmitter, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { AppConfig } from 'app/app.config';
import { ISlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { enumToDescriptedArray } from 'app/shared/enums/mapper';
import { EnumLiquidationStatus } from 'app/shared/enums/liquidation-status.enum';
import { IDtoEmployeeLiquidation } from 'app/shared/models/legal/dto-employee-liquidation.model';
import { LiquidationService } from 'app/views/appviews/liquidation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalDemandCostComponet } from '../../../../modales/demand/demand-cost/modal-demand-cost.component';
import { saveAs } from 'file-saver';
import { IDtoSolicitudDinero } from 'app/shared/models/money/dto-solicitud-dineto.model';
import { ModalDiscountDismissalComponet } from 'app/views/modales/liquidation/discount/modal-discount-dismissal.component';
import { IDocument } from 'app/shared/models/recruitment/document.model';
import { IResult } from 'app/shared/models/result.model';
import { DocumentService } from 'app/shared/services/document.service';
import { DatePipe } from '@angular/common';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { DemandService } from 'app/views/appviews/demand.service';
import { EmployeeService } from 'app/views/appviews/employee.service';
import { IDtoLiquidation } from 'app/shared/models/legal/dto-liquidation.model';
import { IDtoSettlement } from 'app/shared/models/legal/dto-settlement.model';
import { ModalReportLiquidationComponet } from 'app/views/modales/liquidation/reports/modal-report-liquidation.component';
@Component({
  selector: 'app-list-liquidations',
  styleUrls: ['./list-liquidations.style.scss'],
  templateUrl: 'list-liquidations.template.html'
})
export class ListLiquidationsComponent implements OnDestroy, OnInit {
  private modalRef: BsModalRef;
  /**Formularios */
  private formFilter: FormGroup;
  /**Notificaciones */
  private configToast: any;
  private catalogLiquidationStatus: IDtoCatalog[];
  private employeeLiquidations: IDtoEmployeeLiquidation[];
  private employeeLiquidationsTemp: IDtoEmployeeLiquidation[];
  private solicitudDinero: IDtoSolicitudDinero;
  /**Variables */
  public nav: any;
  private now: number;
  /**Slim-control */
  optsSlim: ISlimScrollOptions;
  scrollEvents: EventEmitter<SlimScrollEvent>;
  employeeLiquidation: IDtoEmployeeLiquidation;
  private document = {} as IDtoDocument;
  private fileName = '';
  search: string;
  private profile: string;
  settlement: IDtoSettlement;
  public constructor(private formBuilder: FormBuilder
    , public snotifyService: SnotifyService
    , private configGeneral: AppConfig
    , private spinner: NgxSpinnerService
    , private configurationService: ConfigurationService
    , private securityService: SecurityService
    , private liquidationService: LiquidationService
    , private router: Router
    , private route: ActivatedRoute
    , private modalService: BsModalService
    , private datePipe: DatePipe
    , private documentService: DocumentService
    , private demandService: DemandService
    , private employeeService: EmployeeService) {
    this.nav = document.querySelector('nav.navbar');
    this.configToast = configGeneral.getConfigToast();
    this.optsSlim = configGeneral.getConfigSlimScroll();
    this.initializeFormFilter();
  }

  public ngOnInit(): any {
    this.profile = this.securityService.getProfileStorage('LiquidationRecords');
    this.scrollEvents = new EventEmitter<SlimScrollEvent>();
    this.now = Date.now();
    this.nav.className += ' white-bg';
    if (this.configurationService.isReady) {
      this.obetenerCatalogos();
    } else {
      this.configurationService.settingsLoaded$.subscribe(() => {
        //this.spinner.show();
        this.obetenerCatalogos();
      });
    }
  }
  private getLiquidationsByStatusId(): void {
    let statusId = this.formFilter.value.statusId;
    if (statusId == undefined) {
      this.configGeneral.newToast('Validación', 'Seleccione un estatus para poder filtrar', 'warning');
      return;
    }
    this.spinner.show()
    if (this.formFilter.value.module == 'L') {
      this.liquidationService.getLiquidationsByStatusId(statusId)
        .subscribe(
          (x) => {
            if (x.isCorrect) {
              this.employeeLiquidations = x.data as IDtoEmployeeLiquidation[];
              this.employeeLiquidationsTemp = this.employeeLiquidations;
            } else {
              this.configGeneral.newToast('Error', x.message, 'error');
            }
            this.spinner.hide();
          },
          (errMessage) => {
            this.spinner.hide();
            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
          });
    } else {
      this.demandService.getDemandsByStatusId(statusId)
        .subscribe(
          (x) => {
            if (x.isCorrect) {
              this.employeeLiquidations = x.data as IDtoEmployeeLiquidation[];
              this.employeeLiquidationsTemp = this.employeeLiquidations;
            } else {
              this.configGeneral.newToast('Error', x.message, 'error');
            }
            this.spinner.hide();
          },
          (errMessage) => {
            this.spinner.hide();
            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
          });
    }
  }
  private obetenerCatalogos(): void {
    this.catalogLiquidationStatus = enumToDescriptedArray(EnumLiquidationStatus) as IDtoCatalog[];
  }
  private initializeFormFilter() {
    this.formFilter = this.formBuilder.group({
      customerId: [null],
      projectId: [null],
      payrollTypeId: [null],
      periodNom: [null],
      year: [null],
      module: [null],
      statusId: [null]
    });
  }
  public ngOnDestroy(): any {
    this.nav.classList.remove('white-bg');
  }
  private navigateTo(row: IDtoEmployeeLiquidation): void {
    const values = this.formFilter.value;
    //this.storageService.store('payrolls.filters', values);
    //this.storageService.store('payrolls.search', this.search);
    this.router.navigate(['/legal/liquidation',
      { liquidationId: row.id, employeeId: row.employeeId, actionLiquidation: 'update', requisitionId: row.requisitionId }], { relativeTo: this.route });
  }
  private goDemand(row: IDtoEmployeeLiquidation): void {
    const values = this.formFilter.value;
    //this.storageService.store('payrolls.filters', values);
    //this.storageService.store('payrolls.search', this.search);
    this.router.navigate(['/legal/demand',
      { liquidationId: row.id, employeeId: row.employeeId, actionLiquidation: 'update', requisitionId: row.requisitionId }], { relativeTo: this.route });
  }
  private openModalDemandCost(row: IDtoEmployeeLiquidation) {
    const initialState = {
      liquidationId: row.id,
      settlement: row.settlement
    };
    this.modalService.show(ModalDemandCostComponet
      , Object.assign({ initialState }
        , { class: 'modal-lg' }
        , this.configGeneral.configModal));
  }
  private openModalDiscount(row: IDtoEmployeeLiquidation) {
    const initialState = {
      employeeId: row.employeeId,
      requisitionId: row.requisitionId
    };
    this.modalService.show(ModalDiscountDismissalComponet
      , Object.assign({ initialState }
        , { class: 'modal-lg' }
        , this.configGeneral.configModal));
  }
  private downloadLiquidation(): void {
    this.spinner.show();
    this.liquidationService.downloadFileLiquidation(this.employeeLiquidation.employeeId, this.employeeLiquidation.id, this.employeeLiquidation.requisitionId).subscribe((res) => {
      if (res.isCorrect === true) {
        const file = res.data as any;
        const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
        saveAs(blob, file.fileDownloadName);
        this.spinner.hide();
      } else {
        this.configGeneral.newToast('Error', res.message, 'error');
        this.spinner.hide();
      }

    },
      (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
      });
  }
  private downloadLiquidationSimple(): void {
    this.spinner.show();
    this.liquidationService.downloadFileLiquidationSimple(this.employeeLiquidation.employeeId, this.employeeLiquidation.id, this.employeeLiquidation.requisitionId).subscribe((res) => {
      if (res.isCorrect === true) {
        const file = res.data as any;
        const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
        saveAs(blob, file.fileDownloadName);
        this.spinner.hide();
      } else {
        this.configGeneral.newToast('Error', res.message, 'error');
        this.spinner.hide();
      }

    },
      (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
      });
  }
  private obtenerDatosSolicitudDinero(item: IDtoEmployeeLiquidation, template: TemplateRef<any>): void {
    this.spinner.show()
    this.solicitudDinero = {} as IDtoSolicitudDinero;
    this.liquidationService.obtenerDatosSolicitudDinero(item.id, 'Liquidation')
      .subscribe(
        (x) => {
          if (x.isCorrect) {
            this.solicitudDinero = x.data as IDtoSolicitudDinero;
            this.modalRef = this.modalService.show(template);
          } else {
            this.configGeneral.newToast('Error', x.message, 'error');
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private descargarLiquidacion(item: IDtoEmployeeLiquidation, template: TemplateRef<any>): void {
    this.employeeLiquidation = item;
    this.getDocumentLiquidation();
    this.modalRef = this.modalService.show(template);
  }
  private onFileChange(event) {
    event.value = '';
  }
  private handleFileInput(files: FileList) {
    const file = files.item(0);
    let ext = file.name.split('.').pop();
    if (ext == 'pdf') {
      this.upload(file);
    } else {
      this.configGeneral.newToast('Validación', `Asegúrese de seleccionar el tipo de archivo correcto (.pdf)`, 'error');
    }
  }
  private upload(file: File): void {
    if (file != undefined) {
      this.spinner.show();
      let document = {} as IDtoDocument;
      const fileName = file.name;
      let sp = fileName.split('.').pop();
      let fileNameNew = `${this.employeeLiquidation.id}_LiquidacionEmpleado_${this.datePipe.transform(new Date(), 'ddMMyyyy')}.${sp}`;
      document.fileName = fileNameNew;
      this.fileName = fileNameNew;
      document.referenceId = this.employeeLiquidation.id;
      document.folder = 'Liquidaciones';
      document.module = 'Liquidation';
      document.name = "Liquidacion";
      document.acceptDuplicate = true;
      document.isReplaced = true;
      this.documentService.addDocument(document, file).subscribe((res) => {
        if (res.isCorrect === true) {
          this.configGeneral.newToast('Éxito', res.message, 'success');
          this.document = res.data as IDtoDocument;
          this.fileName = this.document.fileName;
        } else {
          this.configGeneral.newToast('Error', res.message, 'error');
        }
        this.spinner.hide();
      },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
    }
  }
  private downloadFile(id: number): void {
    this.documentService.downloadFile(id).subscribe((res) => {
      if (res.isCorrect === true) {
        const file = res.data as any;
        const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
        saveAs(blob, file.fileDownloadName);
        this.spinner.hide();
      } else {
        this.configGeneral.newToast('Error', res.message, 'error');
        this.spinner.hide();
      }
    },
      (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
      });
  }
  private getDocumentLiquidation(): void {
    this.documentService.getLatesDocumentVersion(this.employeeLiquidation.id, 'Liquidacion').subscribe(res => {
      this.document = res.data as IDtoDocument;
      if (this.document == undefined) {
        this.configGeneral.newToast('Validación', 'No tiene documento para descargar', 'error');
        return;
      };
    })
  }
  private updateFilter() {
    if (this.search === undefined) {
      return;
    }

    const val = this.search.toLowerCase();
    const temp = this.employeeLiquidationsTemp.filter((x: any) => x.employeeName.toLowerCase().includes(val)
      || x.employeeNum.toLowerCase().includes(val)
      || x.customer.toLowerCase().includes(val)
      || x.job.toLowerCase().includes(val)
      || x.zone.toLowerCase().includes(val));
    this.employeeLiquidations = temp;
  }
  private getEmployeeData(item: IDtoEmployeeLiquidation, template: TemplateRef<any>): void {
    this.settlement = null;
    this.spinner.show();
    this.employeeService.getEmployeeDataDismissalById(item.requisitionId).subscribe((res) => {

      let dto = {} as IDtoLiquidation;
      dto.employeeId = res.id;
      dto.employeeNum = res.employeeNum;
      dto.employeeCompanyId = res.employeeCompanyId;
      dto.dismissalDate = res.dismissalDate;
      dto.hiringDate = res.hiringDate;
      dto.jobId = res.jobId;
      dto.dailySalary = res.dailySalary;
      dto.assimilatedCommission = res.assimilatedCommission;
      dto.id = item.id;
      dto.requisitionId = res.requisitionId;
      this.spinner.hide();
      this.getDetailSettlementEmployee(dto, template);
    });
  }
  private getDetailSettlementEmployee(dto: IDtoLiquidation, template: TemplateRef<any>): void {
    this.spinner.show()
    this.liquidationService.getDetailSettlementEmployee(dto)
      .subscribe(
        (x) => {
          if (x.isCorrect) {
            this.settlement = x.data as IDtoSettlement;
            this.modalRef = this.modalService.show(template);
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private goDownloadLiquidations(): void {
          this.modalRef = this.modalService.show(ModalReportLiquidationComponet
              , Object.assign(this.configGeneral.configModal));
  }
}
